
import axios from '../config/axios';

export const url = '/api/certificationsdb'


export const createcertificationsdb = ({
  token,
	namecertificate,
	productrelationdb,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token ) {
		const formData = new FormData();
		formData.append('loftyFile', loftyFile);
		formData.append('namecertificate', namecertificate);
		formData.append('productrelationdb', productrelationdb);

    axios.post(`${url}//create/basic/68f16fe2a5fe5912e6005ca5`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',

        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      
export const getOnecertificationsdb = ({
  token,
  _id,
}) => new Promise((resolve, reject) => {
  if (token && _id) {
    axios.get(`${url}//one/basic/68f16fe4a5fe5912e6005cb2/${_id}`, {
      headers: {
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch((error) => reject(error));
  } else if (!_id) {
    reject({
      status: 'error',
      info: 'Identificador no definido'
    });
  } else {
    reject({
      status: 'error',
      info: 'Token no definido',
    });
  }
});
      
export const getAllcertificationsdb = ({
  token,
}) => new Promise((resolve, reject) => {
  if (token) {
    axios.get(`${url}//list/basic/68f16fe6a5fe5912e6005cbf`, {
      headers: {
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch((error) => reject(error));
  } else {
    reject({
      status: 'error',
      info: 'Token no definido',
    });
  }
});
      

